import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';


/**
 * Bold Magazine layout — editorial style.
 * Large centered title with no glass card. Thin divider line.
 * Footer pinned at bottom for cross-template consistency.
 */
export function BoldMagazineLayout({ data, fontPreset, pc }) {
  const divider = (
    <div className="mt-8 mb-6">
      <div className="w-full h-[2px]" style={{ backgroundColor: pc.text(0.20) }} />
    </div>
  );

  return (
    <div className="absolute inset-[64px] flex flex-col">
      {/* Top spacer */}
      <div className="flex-1 min-h-[80px]" />

      {/* Content block */}
      <NudgeableGroup groupId="content" className="px-[24px]">
        <SlideContent
          data={data}
          fontPreset={fontPreset}
          pc={pc}
          options={{
            showFooter: false,
            afterTitle: divider,
            titleClass: 'text-center',
          }}
        />
      </NudgeableGroup>

      {/* Bottom spacer */}
      <div className="flex-1 min-h-[40px]" />

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-0 left-0 right-0">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
